import { useState } from "react";
import { useDispatch } from "react-redux";
import { searchByTitle } from "../../features/filter/filterSlice";

const Search = () => {
    const [text, setText] = useState("");

    const dispatch = useDispatch();

    const handleChange = (e) => {
        setText(e.target.value);
        dispatch(searchByTitle(e.target.value));
    };

    return (
        <div className="search-field group flex-1">
            <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
            <input
                type="text"
                placeholder="Search Job"
                className="search-input"
                id="lws-searchJob"
                value={text}
                onChange={handleChange}
            />
        </div>
    );
};

export default Search;
